import { schema } from 'normalizr';
export const userSchema = new schema.Entity('user', {}, {
    idAttribute: 'userId'
});
export const userListSchema = [
    userSchema
];
